module.exports = __webpack_public_path__ + "img/loisirhoteltoyohashi.dca515f5.png";